<template>
	<div>
	    <!--导航栏 start-->
	    <van-nav-bar
	            title="会员管理"
	            left-text="返回"
	            @click-left="onClickLeft"
	            left-arrow
	            fixed
	    />
	    <!--导航栏 end-->
	    <!--内容 start-->
	    <div style="margin-top: 1.5rem">
	        <van-cell title="会员列表" is-link @click="member_list"/>
	        <van-cell title="余额明细" is-link @click="balance"/>
	        <van-cell title="积分明细" is-link @click="integral"/>
	        <van-cell title="会员卡管理" is-link @click="member_card"/>
	    </div>
	    <!--内容 end-->
	</div>
</template>

<script>
	export default {
	    name: "member", //商户信息
	    methods: {
	        // 左侧返回
	        onClickLeft() {
	            this.$router.push("/MerchantHomepage");
	        },
	        // 会员列表
	        member_list() {
	            // 跳转至会员列表
	            this.$router.push("/member_list");
	        },
	        // 余额明细
	        balance() {
	            // 跳转至余额明细
	            this.$router.push("/balance");
	        },
	        // 积分明细
	        integral() {
	            // 跳转至积分明细
	            this.$router.push("/integral");
	        },
			member_card() {
	            // 跳转至会员卡
	            this.$router.push("/member_card");
	        },
	        
	    },
	}
</script>

<style>
</style>
